import { ProfileReviewSourcesAPI } from './profile-review-sources';
import moment from 'moment';

export const ProfileImportReviews = () => {
	const profileReviewSourcesAPI = ProfileReviewSourcesAPI();

	const { Handlebars } = window;

	const templateConfig = {
		containerId: 'import-reviews-fb',
		templateId: 'import-reviews-fb-template',
	};

	const state = {
		existingUrl: null,
		reviewSourceData: null,
		reviewsImporting: false,
		reviewsImported: false,
		canEdit: false,
		foundExistingUrl: false,
		hasExistingUrl: false,
	};

	const init = async (selfData) => {
		checkForExistingUrl(selfData);
		await getSources();
	};

	const getSources = () => {
		profileReviewSourcesAPI.getReviewSources((response) => {
			updateState(response);
			drawSection();
			bindListners();
		}, false);
	};

	const updateSource = () => {
		removePageError();

		let fbPage = getFacebookImportPage();

		if (!isValidFacebookPage(fbPage)) {
			addPageError(
				_t('seller_settings_profile:invite-reviews.error.invalid-facebook-link'),
			);
			removeLoader();
			return;
		}

		let payload = {
			data: formatPageUrl(fbPage),
			source: 'user',
			type: 'facebook',
		};

		profileReviewSourcesAPI.updateReviewSource(
			state.reviewSourceData.id,
			payload,
			(response) => {
				resetToDefaultState();
				updateState(response);
				drawSection();
				bindListners();
				removeLoader();
			},
			false,
		);
	};

	const addSources = (confirmUpdateOnExistingUrl = true) => {
		removePageError();

		let fbPage = getFacebookImportPage();

		if (!isValidFacebookPage(fbPage)) {
			addPageError(
				_t('seller_settings_profile:invite-reviews.error.invalid-facebook-link'),
			);
			removeLoader();
			return;
		}

		if (
			confirmUpdateOnExistingUrl &&
			state.hasExistingUrl &&
			!isValidExistingUrlUpdate()
		) {
			showUrlConfirmModal();
			removeLoader();
			return;
		}

		let payload = {
			review_sources: [
				{
					data: formatPageUrl(fbPage),
					source: 'user',
					type: 'facebook',
				},
			],
		};

		profileReviewSourcesAPI.saveReviewSources(
			payload,
			(response) => {
				resetToDefaultState();
				updateState(response);
				drawSection();
				bindListners();
				removeLoader();
			},
			false,
		);
	};

	const getFacebookImportPage = () => {
		return $('#import-reviews-fb')
			.find('input[name="facebook-import-page"]')
			.val()
			.trim();
	};

	const addPageError = (errorMessage) => {
		$('#import-reviews-fb')
			.find('input[name="facebook-import-page"]')
			.addClass('is-invalid');
		$('#import-reviews-fb').find('.import-facebook-page-error').text(errorMessage);
	};

	const removePageError = () => {
		$('#import-reviews-fb')
			.find('input[name="facebook-import-page"]')
			.removeClass('is-invalid');
		$('#import-reviews-fb').find('.import-facebook-page-error').empty();
	};

	const isValidFacebookPage = (url) => {
		return url && /^(https?:\/\/)?((w{3}\.)?)facebook.com\/.*/i.test(url);
	};

	const formatPageUrl = (url) => {
		if (!/^(https?:\/\/)/i.test(url)) {
			return `https://${url}`;
		}
		return url;
	};

	const isValidExistingUrlUpdate = () => {
		let fbPage = getFacebookImportPage();
		return fbPage === state.existingUrl;
	};

	const showUrlConfirmModal = () => {
		$('#confirm-fb-page-update-modal').modal('show');
	};

	const hideUrlConfirmModal = () => {
		$('#confirm-fb-page-update-modal').modal('hide');
	};

	const resetToDefaultState = () => {
		state.existingUrl = null;
		state.reviewSourceData = null;
		state.reviewsImporting = false;
		state.reviewsImported = false;
		state.canEdit = false;
		state.foundExistingUrl = false;
		state.hasExistingUrl = false;
	};

	const updateState = (response) => {
		let facebookData;
		if (Array.isArray(response.data) && response.data.length) {
			response.data.forEach((item) => {
				if (item.attributes?.type === 'facebook') {
					facebookData = item;
				}
			});
		} else if (response.data && Object.keys(response.data).length) {
			if (response.data.attributes?.type === 'facebook') {
				facebookData = response.data;
			}
		}
		state.reviewSourceData = facebookData ? facebookData : state.reviewSourceData;
		if (state.existingUrl && !state.reviewSourceData) {
			state.hasExistingUrl = true;
		}

		if (state.reviewSourceData) {
			state.canEdit = true;

			let currentTime = moment().utc();
			let updatedAt = moment.utc(
				state.reviewSourceData.attributes.updated_at.date,
				'YYYY-MM-DD HH:mm:SS',
			);
			if (currentTime.diff(updatedAt, 'h') >= 24) {
				state.reviewsImported = true;
			} else {
				state.reviewsImporting = true;
			}

			if (state.reviewSourceData?.attributes?.source === 'website') {
				state.foundExistingUrl = true;
			}
		}
	};

	const drawSection = () => {
		let importFbReviewsTemplate = Handlebars.compile(
			document.getElementById(templateConfig.templateId).innerHTML,
		);
		let importFbReviewsHtml = importFbReviewsTemplate(state);
		$(`#${templateConfig.containerId}`).empty().append(importFbReviewsHtml);
	};

	const bindListners = () => {
		$('#import-reviews-fb .js-change-link').on('click', function (e) {
			e.preventDefault();
			showEditSection();
		});

		$('#import-reviews-fb .js-cancel-change-link').on('click', function (e) {
			e.preventDefault();
			hideEditSection();
		});

		$('#import-reviews-fb .js-update-import-facebook-page').on('click', function (e) {
			e.preventDefault();
			$(this).addClass('submit-waiting');
			updateSource();
		});

		$('#import-reviews-fb .js-import-facebook-page').on('click', function (e) {
			e.preventDefault();
			$(this).addClass('submit-waiting');
			addSources();
		});

		$('#confirm-fb-page-update-modal .js-confim-fb-page-import').on(
			'click',
			function (e) {
				e.preventDefault();
				hideUrlConfirmModal();
				$('#import-reviews-fb .js-import-facebook-page').addClass('submit-waiting');
				addSources(false);
			},
		);
	};

	const showEditSection = () => {
		$('#import-reviews-fb .js-edit-section').removeClass('d-none');
		$('#import-reviews-fb .js-connected-section').addClass('d-none');
		$('#import-reviews-fb .js-sub-title').addClass('d-none');
	};

	const hideEditSection = () => {
		$('#import-reviews-fb .js-edit-section').addClass('d-none');
		$('#import-reviews-fb .js-connected-section').removeClass('d-none');
		$('#import-reviews-fb .js-sub-title').removeClass('d-none');
	};

	const removeLoader = () => {
		$('#import-reviews-fb .settings-submit').removeClass('submit-waiting');
	};

	const checkForExistingUrl = (selfData) => {
		if (selfData?.links?.facebook) {
			state.existingUrl = formatPageUrl(selfData.links.facebook);
		}
	};

	return {
		init,
	};
};
